import React from 'react';

import MinimizableWebChat from './MinimizableWebChat';
import './App.css';

const App = () => (
  <div className="App">
    <MinimizableWebChat />
  </div>
);

export default App;